import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.GET_LIST_WAREHOUSE.REQUEST, saga.fetchWarehouse);
}